export type CheckboxProps = {
  option?: string
  field?: string
  tempSelected?: string[]
  availableOptions?: string[]
  toggleOption: (field: string, value: string) => void
}
export default function Checkbox({ option, field, tempSelected, availableOptions, toggleOption }: CheckboxProps) {
  const toggleOptionCheck = () => {
    if (availableOptions.includes(option)) {
      toggleOption(field, option)
    }
  }
  return (
    <li className="cmp-filterbar__checkbox-item" key={option}>
      <div className="cmp-filterbar__checkbox-item-wrapper" onClick={toggleOptionCheck}>
        <div
          className={`cmp-filterbar__checkbox-input ${tempSelected.includes(option) ? 'cmp-filterbar__checkbox-input--is-checked' : ''} ${!availableOptions.includes(option) ? 'cmp-filterbar__checkbox-input--is-disabled' : ''}`}
          role="checkbox"
          aria-checked={tempSelected.includes(option)}
          aria-label={option}
          tabIndex={0}
        >
          <span dangerouslySetInnerHTML={{ __html: option }}></span>
        </div>
      </div>
    </li>
  )
}
